import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Loader, { LoaderSizes } from './Loader';
import './LoadingContainer.scss';
var OverlayColors = {
    WHITE: 'white',
    GRAY5: 'gray5',
    GRAY10: 'gray10',
    GRAY20: 'gray20'
};
var LoadingContainer = function (_a) {
    var children = _a.children, className = _a.className, isLoading = _a.isLoading, isSticky = _a.isSticky, minHeight = _a.minHeight, overlayColor = _a.overlayColor, size = _a.size, props = __rest(_a, ["children", "className", "isLoading", "isSticky", "minHeight", "overlayColor", "size"]);
    var loaderClassName = classnames('LoadingContainer__loader', "LoadingContainer__loader--".concat(size), {
        'LoadingContainer__loader--isSticky': isSticky
    });
    var containerClassName = classnames('LoadingContainer', className);
    var overlayClassName = classnames('LoadingContainer__overlay', "LoadingContainer__overlay--".concat(overlayColor));
    return (React.createElement("div", __assign({}, props, { className: containerClassName, style: { minHeight: isLoading ? minHeight : 0 } }),
        isLoading && (React.createElement("div", { className: overlayClassName },
            React.createElement("div", { className: 'LoadingContainer__loaderWrapper' },
                React.createElement(Loader, { className: loaderClassName, size: size })))),
        children));
};
LoadingContainer.defaultProps = {
    isSticky: false,
    minHeight: 0,
    overlayColor: OverlayColors.WHITE,
    size: LoaderSizes.MEDIUM
};
LoadingContainer.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    isSticky: PropTypes.bool,
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    overlayColor: PropTypes.oneOf(Object.values(OverlayColors)),
    size: PropTypes.oneOf(Object.values(LoaderSizes))
};
export default LoadingContainer;
//# sourceMappingURL=LoadingContainer.js.map